import React from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";
import { format, parseISO } from "date-fns";
import { es } from "date-fns/locale";

/**
 * DatePicker - shadcn Calendar wrapped as a controlled date field
 * Value/onChange use ISO string (YYYY-MM-DD).
 */
export default function DatePicker({ value, onChange, placeholder = "dd/mm/aaaa", testid }) {
  const date = value ? parseISO(value) : null;
  const label = date && !isNaN(date.getTime()) ? format(date, "dd/MM/yyyy") : "";
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          className={`input text-left flex items-center justify-between ${!label ? "text-slate-400" : ""}`}
          data-testid={testid}
        >
          <span>{label || placeholder}</span>
          <svg className="w-4 h-4 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                  d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
          </svg>
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 z-[60]" align="start">
        <Calendar
          mode="single"
          locale={es}
          selected={date || undefined}
          onSelect={(d) => {
            if (!d) {
              onChange("");
              return;
            }
            const y = d.getFullYear();
            const m = String(d.getMonth() + 1).padStart(2, "0");
            const day = String(d.getDate()).padStart(2, "0");
            onChange(`${y}-${m}-${day}`);
          }}
          initialFocus
        />
        <div className="flex justify-between p-2 border-t">
          <button type="button" className="text-xs text-slate-500 hover:text-red-600"
                  onClick={() => onChange("")}>
            Limpiar
          </button>
          <button type="button" className="text-xs text-[var(--cvt-blue)] font-semibold"
                  onClick={() => {
                    const d = new Date();
                    const y = d.getFullYear();
                    const m = String(d.getMonth() + 1).padStart(2, "0");
                    const day = String(d.getDate()).padStart(2, "0");
                    onChange(`${y}-${m}-${day}`);
                  }}>
            Hoy
          </button>
        </div>
      </PopoverContent>
    </Popover>
  );
}
